import React from 'react';

import { GOAL_PROGRESSES } from 'constants/ProjectConstants';
import { notNullOrUndefined } from 'constants/helper';

import { SplitProgressBar } from 'uiToolkitV1/ProgressBar';

const KEYS_FOR_PROGRESS_BAR = GOAL_PROGRESSES.map(({ value }) => value);

const COLOR_MAP = {
  ON_TRACK: '#B1E39F',
  OFF_TRACK: '#FCC88B',
  AT_RISK: '#FD9B9B',
  CLOSED: '#666666',
};

const ObjectiveProgressBar = ({ data, percentageValue }) => {
  const modifiedData = KEYS_FOR_PROGRESS_BAR.map((progressLevel) => {
    if (notNullOrUndefined(data[progressLevel]?.avgCompletionPercentage)) {
      return {
        weight: +data[progressLevel]?.avgCompletionPercentage === 0 ? 1 : +data[progressLevel]?.avgCompletionPercentage,
        color: COLOR_MAP[progressLevel],
      };
    }
  }).filter((dObj) => !!dObj);

  return (
    <SplitProgressBar
      size="large"
      data={modifiedData}
      totalWeight={100}
      showPercentage
      percentageValue={percentageValue}
    />
  );
};
export default ObjectiveProgressBar;
